/**
 * Where a free learner's milestone line goes once their save has reached one
 * (CB-61).
 *
 * The handler draws the line, as it draws the standing panel, and this only
 * places it. In the panel the save opened, under what the panel says, where
 * there is one. A control with no panel, a row of `/user/ci/` or a word in the
 * segmenter, takes it straight after itself. A page holds one line at most:
 * a learner who reaches a second milestone without reloading sees the newer
 * line in place of the older, which the handler has already claimed.
 */

/** The class `src/user/milestone-markup.ts` gives the line. */
const milestoneSelector = ".cb-milestone";

/**
 * Put the line where the learner will see it.
 * @param panel - The panel the save opened, where it opened one.
 * @param control - The save control that was pressed.
 * @param markup - The line, as the handler drew it.
 */
export function showMilestone(
  panel: HTMLElement | undefined,
  control: HTMLElement,
  markup: string,
): void {
  const document = control.ownerDocument;

  document.querySelector(milestoneSelector)?.remove();

  if (panel === undefined) {
    control.insertAdjacentHTML("afterend", markup);
  } else {
    panel.insertAdjacentHTML("beforeend", markup);
  }
}
